module.exports = __webpack_public_path__ + "img/dashboard_detail_arrow.b9b14e0a.svg";